import { useState, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Context, { AccessContext } from './context.js';
import Header from './header.js';
import Footer from './footer.js';
import MobileMenu from './mobile-menu.js';
import SideNav from './side-nav.js';
import axios from 'axios';

const PrivateRoute = () => {
    const location = useLocation();
    const isLoggedIn = localStorage.getItem('jwt');
    const [context, setContext] = useState('');
    const [access, setAccess] = useState({});
    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + 'getauth')
            .then(r => {
                setAccess(r?.data);
            });
    }, [location]);
    return isLoggedIn ? (
        <Context.Provider value={[context, setContext]}>
            <AccessContext.Provider value={access}>
                {location.pathname.startsWith('/protected/') ? (
                    <Outlet />
                ): (
                    <div className="flex a-start f-col a-stretch">
                        <MobileMenu />
                        <Header />
                        <div className="grow p-rel flex a-start f-stretch">
                            <SideNav />
                            <div className="w-100 page-bg">
                                <div className="mw-1100 w-100">
                                    <Outlet />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </AccessContext.Provider>
        </Context.Provider>
    ) : <Navigate to="/login" />;
}

export default PrivateRoute;